import './index.scss';

import { useContext, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { ThemeChangeContext } from '../../../context/themeChangeContext';
import Career from '../../Career';
import Intro from '../../Intro';
import Projects from '../../Projects';
import PageWrapper from '../../common/PageWrapper';

const Home = () => {
  const { darkTheme } = useContext(ThemeChangeContext);
  const nodeRef = useRef(null);

  return (
    <CSSTransition classNames='fade' in={!darkTheme} timeout={300} nodeRef={nodeRef}>
      <PageWrapper ref={nodeRef}>
        <Intro />
        <Career />
        <Projects />
      </PageWrapper>
    </CSSTransition>
  );
};

export default Home;
